  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });

document.querySelectorAll('.addon-hidden-checkbox').forEach(checkbox => {
  checkbox.addEventListener('change', function() {
    const label = this.nextElementSibling;
    label.setAttribute('aria-checked', this.checked);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const siteHeader = document.querySelector('.site-header');
  const siteNavLinks = document.querySelectorAll('.site-navigation .site-nav__link');
  let isHovering = false;

  siteNavLinks.forEach(link => {
    const parentItem = link.closest('.site-nav__item');

    link.addEventListener('mouseenter', () => {
      isHovering = true;
      siteHeader.classList.add('nav-item-hovered');
    });

    parentItem.addEventListener('mouseleave', (event) => {
      // Check if the mouse has moved to a child element (submenu)
      if (!parentItem.contains(event.relatedTarget)) {
        isHovering = false;
        // Small delay to ensure we're not in another nav item
        setTimeout(() => {
          if (!isHovering) {
            siteHeader.classList.remove('nav-item-hovered');
          }
        }, 50);
      }
    });
  });
});